import { useState } from "react";
import "./enquiryform.css";

function EnquiryForm() {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = "919524655853";

const text = `Hello! I am ${name}.\n${message}`;
const encodedText = encodeURIComponent(text);


    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedText}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="enquiry-container">
      <h2 className="enquiry-title">Send us an Enquiry</h2>
      <form onSubmit={handleSubmit} className="enquiry-form">
        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <textarea
          placeholder="Your Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        ></textarea>
        <button type="submit" className="enquiry-btn">
          Send on WhatsApp
        </button>
      </form>
    </div>
  );
}

export default EnquiryForm;
